import { ONLY_EXCLUSIVE_ANSWERS, PollConfig } from '../../../../configFields';
import { POLL_RATING_SLIDER as QuestionType } from '../../../../types/webview.generated';
import { RATING_TYPE } from '../configFields';

export const config: PollConfig & { name: 'POLL_RATING_SLIDER' } = {
  name: 'POLL_RATING_SLIDER' as const,
  traits: [RATING_TYPE, ONLY_EXCLUSIVE_ANSWERS],
  title: 'Рейтинг: слайдер',
  tracker: (_question: QuestionType) => {
    return trackingData => ({
      ...trackingData,
      question_type: 'POLL_RATING',
    });
  },
};
